export const REPORT_FORM_CONFIRMATION_ROUTE = 'potwierdzenie';
export const REPORT_FORM_ROUTE = 'formularz';
export const REPORT_CARD_DAMAGE_OR_LOSS_ROUTE =
  'zglos-zgubienie-uszkodzenie-lub-kradziez-karty-do-tachografu';
